import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import DescriptionField from "components/support/description-field";
import { observer } from "mobx-react";

class StockInfo extends Component {
  render() {
    const { product } = this.props;

    return (
      <div className="grid-container">
        <Row>
          <Col xs={12} lg={6}>
            <DescriptionField
              label="Estoque Mínimo"
              value={product.restock_count}
            />
          </Col>
          <Col xs={12} lg={6}>
            <DescriptionField
              label="Estoque Atual"
              value={product.stock_count}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default observer(StockInfo);



// WEBPACK FOOTER //
// ./src/components/app/registration/product/info/stock-info/index.jsx